import React, { useState } from 'react';
import BicycleGameForm from '../components/gameBicycle/BicycleGameForm';
import Counter from '../components/gameBicycle/Counter';
import KozelMembership from '../components/gameBicycle/KozelMembership';
import Prizes from '../components/gameBicycle/Prizes';
import Slider from '../components/gameBicycle/Slider';
import BicycleGame from '../components/gameBicycle/BicycleGame';

const BicycleLandingPage: React.FC = () => {
    const [showGame, setShowGame] = useState(false);

    const handleStartGame = () => {
        setShowGame(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            {showGame ? (
                <BicycleGame />
            ) : (
                <>
                    <Prizes onStartGame={handleStartGame} />
                    <Counter onStartGame={handleStartGame} />
                    {/* <BicycleGameForm onStartGame={handleStartGame} /> */}
                    {/* <KozelMembership /> */}
                    <Slider interval={5000} />
                </>
            )}
        </div>
    );
};

export default BicycleLandingPage;